// Chapter 5 writing frames ("מסגרות"), uploaded 30.10.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch5_fN"> in src/chapters/chapter-5.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH5_FRAMES: Frame[] = [
  {
    "id": "ch5_f1",
    "n": "5.1",
    "title": "הצומת שלי",
    "type": "lines",
    "intro": "עובדות בלבד, בלי פרשנות. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי לו:",
      "לאן נכנסתי (שיחה / החלטה / משימה):",
      "האדום שנשאתי איתי (שם הרגש):",
      "מאיפה הוא באמת הגיע (לרוב ממקום אחר לגמרי):"
    ]
  },
  {
    "id": "ch5_f2",
    "n": "5.2",
    "title": "הגוון שלי בכניסה",
    "type": "scale2",
    "intro": "1 = ירוק לגמרי, 10 = אדום בוהק.",
    "fields": [
      "כמה אדומה הייתי בכניסה לצומת",
      "מה יצא מזה (מה אמרתי, מה החלטתי, מה קרה אחר כך):",
      "אותו צומת, בירוק: מה היה שונה:"
    ]
  },
  {
    "id": "ch5_f3",
    "n": "5.3",
    "title": "שבע השאלות",
    "type": "existing",
    "intro": "שורה אחת מתחת לשאלות שענית עליהן:",
    "fields": [
      "הסימן שהופיע ראשון בצומת שלי (מחשבה / תחושה בגוף / מילה), ואם הוא אותו סימן מפרק 3:"
    ]
  },
  {
    "id": "ch5_f4",
    "n": "5.4",
    "title": "רגשות שליליים: ביטוי והשלכות",
    "type": "existing",
    "intro": "שורה אחת מתחת לטבלה שמילאת:",
    "fields": [
      "המחיר הקטן ששילמתי בצומת, במילים פשוטות:"
    ]
  },
  {
    "id": "ch5_f5",
    "n": "5.5",
    "title": "רגשות חיוביים: ביטוי ומשמעויות",
    "type": "existing",
    "intro": "שתי שורות מתחת לטבלה שמילאת:",
    "fields": [
      "רגש חיובי שהיה זמין לי ביום הצומת ולא הגעתי אליו:",
      "כמה זמן אחרי הצומת הרגש התחלף למשהו רגוע:"
    ]
  },
  {
    "id": "ch5_f6",
    "n": "5.6",
    "title": "המחיר של האדום מול המחיר של ההמתנה",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "כמה זמן הייתי צריכה לחכות לירקרק (דקות / שעה / עד מחר):",
      "מה עלה לי האדום|מה היה עולה לי לחכות"
    ]
  },
  {
    "id": "ch5_f7",
    "n": "5.7",
    "title": "הנטייה, החיזוק, ההרגל",
    "type": "lines",
    "intro": "",
    "fields": [
      "עוד שני צמתים שבהם אותו אדום חוזר:",
      "הנטייה שבאתי איתה (מזג / רגישות / תגובתיות):",
      "מה בסביבה שלי חיזק אותה שוב ושוב:"
    ]
  },
  {
    "id": "ch5_f8",
    "n": "5.8",
    "title": "המשפט של התינוק בצומת שלי",
    "type": "choice5",
    "intro": "סמני הרגל אחד, ואז המשפט:",
    "fields": [
      "רגישות לדחייה · תגובה חזקה לביקורת · ערך שתלוי באחרים · דרוכה תמיד",
      "המשפט של התינוק שמאחורי האדום שלי (\"אם... סימן ש...\"):"
    ]
  },
  {
    "id": "ch5_f9",
    "n": "5.9",
    "title": "שישה שלבים על צומת אחד",
    "type": "lines",
    "intro": "",
    "fields": [
      "1. עוצרת רגע (איפה בדיוק, באיזו שנייה):",
      "2. שואלת: יש כאן סכנת חיים? (מה התשובה):",
      "3. הגוף (דופק / שרירים / נשימה):",
      "4. השם של הרגש:",
      "5. חמלה למי שהייתי כשההרגל נוצר:",
      "6. התגובה האחרת:"
    ]
  },
  {
    "id": "ch5_f10",
    "n": "5.10",
    "title": "מה הילד ראה, מה המבוגר רואה",
    "type": "twocol",
    "intro": "",
    "fields": [
      "הילד ראה בצומת (מוגזם, כמו שזה הרגיש)|המבוגר רואה היום (פשוט, כמו שזה היה)"
    ]
  },
  {
    "id": "ch5_f11",
    "n": "5.11",
    "title": "הצומת שלי, בירוק",
    "type": "final",
    "intro": "",
    "fields": [
      "הצומת שלי, טייק שני (שלוש שורות, אחרי שחיכיתי לירוק):",
      "",
      "",
      "הסימן שאחכה לו לפני הצומת הבא (אותו סימן מפרק 3, או סימן חדש):",
      "המשפט שאגיד לעצמי כשהוא מופיע:"
    ]
  }
];
